import React, { useRef, useState } from "react";
import {
  Box,
  Chip,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@material-ui/core";
import { commonStyles } from "../../../styles";

export const CustomSelectInput = ({
  value = [],
  onChange,
  options = [],
  label = "Select",
  className,
}) => {
  const commonClasses = commonStyles();
  const selectWrapperRef = useRef(null);
  const [menuWidth, setMenuWidth] = useState();

  const handleMenuOpen = () => {
    const fieldWidth = selectWrapperRef.current?.getBoundingClientRect()?.width;
    if (fieldWidth) setMenuWidth(fieldWidth);
  };

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
    PaperProps: {
      className: commonClasses.selectMenuPaper,
      style: menuWidth ? { width: menuWidth } : undefined,
    },
    MenuListProps: { className: commonClasses.selectMenuList },
  };

  const handleChange = (event) => {
    const incomingValue = event.target.value;
    const newValue =
      typeof incomingValue === "string"
        ? incomingValue.split(",").map((item) => item.trim())
        : incomingValue;
    const prev = Array.isArray(value) ? value : [];

    const added = newValue.find((item) => !prev.includes(item));
    const removed = prev.find((item) => !newValue.includes(item));

    if (added !== undefined) onChange(added);
    else if (removed !== undefined) onChange(removed);
  };

  return (
    <div ref={selectWrapperRef}>
      <Select
        multiple
        value={value}
        onChange={handleChange}
        onOpen={handleMenuOpen}
        input={<OutlinedInput label={label} />}
        displayEmpty
        MenuProps={menuProps}
        renderValue={(selected) => {
          if (!selected?.length) return "Select language";
          return (
            <Box className={commonClasses.selectedLanguagesContainer}>
              {selected.map((item) => (
                <Chip
                  key={item}
                  label={item}
                  size="small"
                  className={commonClasses.languageChip}
                  onMouseDown={(event) => event.stopPropagation()}
                  onDelete={() => onChange(item)}
                />
              ))}
            </Box>
          );
        }}
        fullWidth
        className={className}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            className={commonClasses.selectMenuItem}
          >
            <Checkbox checked={value.includes(option)} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};
